module.exports = __webpack_public_path__ + "static/bz_white-b3a09dd98403be19972726769d5fa08b.png";